/**
 * @extends storeLocator.StaticDataFeed
 * @constructor
 */
function WhooshDataSource() {
  $.extend(this, new storeLocator.StaticDataFeed);

  var that = this;
  $.get('//cdn.shopify.com/s/files/1/0622/1453/t/2/assets/apple-us-geocoded.json?v=59244038545152749201418344304', function(data) {
    that.setStores(that.parse_(data));
  });
}

/**
 * @const
 * @type {!storeLocator.FeatureSet}
 * @private
 */

WhooshDataSource.prototype.FEATURES_ = new storeLocator.FeatureSet(
  //new storeLocator.Feature('Wheelchair-YES', 'Wheelchair access'),
  //new storeLocator.Feature('Audio-YES', 'Audio')
);


/**
 * @return {!storeLocator.FeatureSet}
 */
WhooshDataSource.prototype.getFeatures = function() {
  return this.FEATURES_;
};

/**
 * @private
 * @param {string} csv
 * @return {!Array.<!storeLocator.Store>}
 */
WhooshDataSource.prototype.parse_ = function(data) {
  var stores = [];
  
  _.each(data, function(item) {
    var position = new google.maps.LatLng(item.GeocodeLat, item.GeocodeLng);
    
    var store = new storeLocator.Store(Math.random(), position, null, {
      title: item.StoreName,
      address: item.StreetAddress,
      hours: item.BusinessHours
    });
    
    stores.push(store);
  });
  
  return stores;
  
  /*
  var rows =  csv.split('\n');
  var headings = this.parseRow_(rows[0]);

  for (var i = 1, row; row = rows[i]; i++) {
    row = this.toObject_(headings, this.parseRow_(row));
    console.log(row);
    var features = new storeLocator.FeatureSet;
    // features.add(this.FEATURES_.getById('Wheelchair-' + row.Wheelchair));
    // features.add(this.FEATURES_.getById('Audio-' + row.Audio));

    var position = new google.maps.LatLng(row.GeocodeLat, row.GeocodeLng);

    // var shop = this.join_([row.Shp_num_an, row.Shp_centre], ', ');
    // var locality = this.join_([row.Locality, row.Postcode], ', ');

    var store = new storeLocator.Store(Math.random(), position, null, {
      title: row.StoreName,
      address: row.StreetAddress,
      hours: row.BusinessHours
    });
    stores.push(store);
  }
  return stores; */
};

/**
 * Joins elements of an array that are non-empty and non-null.
 * @private
 * @param {!Array} arr array of elements to join.
 * @param {string} sep the separator.
 * @return {string}
 */
WhooshDataSource.prototype.join_ = function(arr, sep) {
  var parts = [];
  for (var i = 0, ii = arr.length; i < ii; i++) {
    arr[i] && parts.push(arr[i]);
  }
  return parts.join(sep);
};

/**
 * Very rudimentary CSV parsing - we know how this particular CSV is formatted.
 * IMPORTANT: Don't use this for general CSV parsing!
 * @private
 * @param {string} row
 * @return {Array.<string>}
 */
WhooshDataSource.prototype.parseRow_ = function(row) {
  // Strip leading quote.
  if (row.charAt(0) == '"') {
    row = row.substring(1);
  }
  // Strip trailing quote. There seems to be a character between the last quote
  // and the line ending, hence 2 instead of 1.
  if (row.charAt(row.length - 2) == '"') {
    row = row.substring(0, row.length - 2);
  }

  row = row.split('","');

  return row;
};

/**
 * Creates an object mapping headings to row elements.
 * @private
 * @param {Array.<string>} headings
 * @param {Array.<string>} row
 * @return {Object}
 */
WhooshDataSource.prototype.toObject_ = function(headings, row) {
  var result = {};
  for (var i = 0, ii = row.length; i < ii; i++) {
    result[headings[i]] = row[i];
  }
  return result;
};

google.maps.event.addDomListener(window, 'load', function() {
  var map = new google.maps.Map(document.getElementById('map-canvas'), {
    center: new google.maps.LatLng(38.7920193, -98.0580799),
    zoom: 3,
    mapTypeId: google.maps.MapTypeId.ROADMAP
  });

  var panelDiv = document.getElementById('panel');

  var data = new WhooshDataSource;

  var view = new storeLocator.View(map, data, {
    geolocation: false,
    features: data.getFeatures()
  });

  new storeLocator.Panel(panelDiv, {
    view: view
  });
});